import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL + "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

/**
 * Si la respuesta dice que la sesión se acabó.
 *
 * Un 403 NO lo dice: significa "no puedes", no "no eres". El servidor lo usa
 * para lo que el permiso o el paquete no habilitan —la constancia o la opinión
 * 32/D de quien no las tiene contratadas, por ejemplo—, y hasta ahora cualquier
 * 403 borraba la sesión y mandaba a /logout: al usuario lo echaba de su propia
 * pantalla por pedir algo que simplemente no le toca ver.
 *
 * Quien avisa de que la sesión murió es el 401 con el token expirado, y ése es
 * el único caso que sigue cerrando la sesión.
 */
export const isSessionExpired = (error) =>
  error?.response?.status === 401 &&
  error?.response?.data?.message === "Expired JWT Token";

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isSessionExpired(error)) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("profile");
      localStorage.removeItem("roles");
      window.location.href = "/logout";
    }
    return Promise.reject(error);
  },
);

export default api;
